import { Alert as MuiAlert, styled } from '@mui/material'
import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles/createTheme'
import { AlertProps } from './Alert.types'

type CssProps = AlertProps & { theme?: Theme }

const bgColorStyles = ({ theme, severity }: Pick<CssProps, 'theme' | 'severity'>) => {
  switch (severity) {
    case 'success':
      return css`
        background-color: ${theme?.palette.common.green[50]};
      `
    case 'warning':
      return css`
        background-color: ${theme?.palette.common.orange[50]};
      `
    case 'error':
      return css`
        background-color: ${theme?.palette.common.red[50]};
      `
    case 'info':
    default:
      return css`
        background-color: ${theme?.palette.common.blue[50]};
      `
  }
}

const colorStyles = ({ theme, severity }: Pick<CssProps, 'theme' | 'severity'>) => {
  switch (severity) {
    case 'success':
      return css`
        background-color: ${theme?.palette.green.main};
        border-color: ${theme?.palette.common.green[50]};
      `
    case 'warning':
      return css`
        background-color: ${theme?.palette.orange.main};
        border-color: ${theme?.palette.common.orange[50]};
      `
    case 'error':
      return css`
        color: ${theme?.palette.error.main};
        border-color: ${theme?.palette.common.red[50]};
      `
    case 'info':
    default:
      return css`
        color: ${theme?.palette.blue.main};
        border-color: ${theme?.palette.common.blue[50]};
      `
  }
}

const borderColorStyles = ({ theme, severity }: Pick<CssProps, 'theme' | 'severity'>) => {
  switch (severity) {
    case 'success':
      return css`
        border: 1px solid ${theme?.palette.common.green[200]};
      `
    case 'warning':
      return css`
        border: 1px solid ${theme?.palette.common.orange[200]};
      `
    case 'error':
      return css`
        border: 1px solid ${theme?.palette.common.red[200]};
      `
    case 'info':
    default:
      return css`
        border: 1px solid ${theme?.palette.common.blue[200]};
      `
  }
}

export const Alert = styled(MuiAlert)`
  position: relative;
  display: flex;
  align-items: center;
  font-weight: normal;
  padding: 12px 16px;
  ${bgColorStyles};
  ${borderColorStyles};

  .MuiAlert-icon {
    margin-right: 16px;
    padding: 0;
    opacity: 1;
    ${colorStyles};
    background-color: transparent;
  }

  .MuiAlert-message {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    color: rgba(0, 0, 0, 87%);
  }

  ul {
    list-style-type: disc;
    padding: 0 0 0 14px;
    margin: 0;
  }
`
